import { render, staticRenderFns } from "./StockTable.vue?vue&type=template&id=375b7464&"
import script from "./StockTable.vue?vue&type=script&lang=js&"
export * from "./StockTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/StockTable.vue
// module id = null
// module chunks = 